var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9495 15.0453C33.3602 15.0408 33.8074 15.0359 34.2137 15.0359C34.6506 15.0359 35 15.3693 35 15.7859V29.1859C35 33.3193 31.4881 36.6693 27.1374 36.6693H13.2469C8.70414 36.6693 5 33.1526 5 28.8193V10.8526C5 6.71927 8.52941 3.33594 12.88 3.33594H22.2102C22.6645 3.33594 23.014 3.68594 23.014 4.1026V9.46927C23.014 12.5193 25.6523 15.0193 28.8497 15.0359C29.5966 15.0359 30.255 15.0412 30.8312 15.0458C31.2795 15.0494 31.678 15.0526 32.0297 15.0526C32.2784 15.0526 32.6008 15.0491 32.9495 15.0453ZM34.0413 13.3337C32.3916 13.3395 30.4469 13.3337 29.048 13.3201C26.8283 13.3201 25 11.5486 25 9.39794V4.27213C25 3.43404 26.0496 3.0179 26.6497 3.62266C27.7355 4.71651 29.2274 6.21996 30.7127 7.7167C32.1952 9.21064 33.671 10.6979 34.7297 11.7644C35.3157 12.3536 34.8862 13.3317 34.0413 13.3337Z",
    fill: "#EC923C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.202C12.5 18.7194 12.9197 18.3281 13.4375 18.3281H26.5625C27.0803 18.3281 27.5 18.7194 27.5 19.202C27.5 19.6847 27.0803 20.0759 26.5625 20.0759H13.4375C12.9197 20.0759 12.5 19.6847 12.5 19.202Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.6981C12.5 22.2155 12.9197 21.8242 13.4375 21.8242H26.5625C27.0803 21.8242 27.5 22.2155 27.5 22.6981C27.5 23.1808 27.0803 23.572 26.5625 23.572H13.4375C12.9197 23.572 12.5 23.1808 12.5 22.6981Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 26.2059C12.5 25.7233 12.9197 25.332 13.4375 25.332H19.0625C19.5803 25.332 20 25.7233 20 26.2059C20 26.6886 19.5803 27.0798 19.0625 27.0798H13.4375C12.9197 27.0798 12.5 26.6886 12.5 26.2059Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublication);
export default __webpack_public_path__ + "static/media/publication.9e0df220.svg";
export { ForwardRef as ReactComponent };